'use client';

import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

const MonthlyExpenditureChart = ({ data }) => {


  const sortedData = data.sort((a, b) => a.sortOrder - b.sortOrder);
  const maxFee = Math.max(...sortedData.map((d) => d.doctorFee));
  const yMax = Math.ceil(maxFee * 1.25) || 100;
   console.log(yMax)
  return (
    <div className="bg-white p-4 rounded-xl shadow-blue_dropshadow w-full">
      <p className="headingText text-coalBlack text-left pb-3">Monthly Earnings</p>
      <div className="h-[250px]">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={sortedData}
            margin={{ top: 5, right: 5, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="feeGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#FFF2E0" stopOpacity={0.8} />
                <stop offset="100%" stopColor="#ffffff" stopOpacity={1} />
              </linearGradient>
            </defs>

            <XAxis
              dataKey="date_range"
              tick={{ fontSize: 10 }}
              axisLine={{ stroke: '#ccc' }}
              tickLine={false}
              interval={0}
            />
            <YAxis
              domain={[0, yMax]}
              tick={{ fontSize: 10 }}
              tickLine={false}
              axisLine={false}
              tickCount={16}
              width={40}
              tickMargin={6}
            />
            <CartesianGrid strokeDasharray="3 3" vertical={false} strokeOpacity={0.1} />
            <Tooltip
              wrapperStyle={{
                fontSize: 10,
                padding: '4px 6px',
                backgroundColor: '#fff',
                border: '1px solid #ddd',
                borderRadius: 4,
              }}
              formatter={(value) => `₹${value.toLocaleString('en-IN')}`}
              labelFormatter={(label) => `Date Range: ${label}`}
            />
            <Area
              type="monotone"
              dataKey="doctorFee"
              stroke="#F39711"
              fill="url(#feeGradient)"
              strokeWidth={2}
              name="Total Fee"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default MonthlyExpenditureChart;
